import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { API_BASE } from './apiConfig'; 

const Partners = () => {
    const { t } = useTranslation(); // ✅ i18n հուկ
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const goldColor = '#c5a059';

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        
        const fetchHeaders = { 
            'ngrok-skip-browser-warning': 'true',
            'Accept': 'application/json'
        };

        fetch(`${API_BASE}/api/partners`, { headers: fetchHeaders })
            .then(res => res.json())
            .then(data => {
                setPartners(data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching partners:", err);
                setLoading(false);
            });

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getPartnerImage = (imgPath) => {
        if (!imgPath) return "https://via.placeholder.com/150?text=No+Logo";
        const cleanPath = imgPath.startsWith('/') ? imgPath : `/${imgPath}`;
        return `${API_BASE}${cleanPath}`.replace(/([^:]\/)\/+/g, "$1");
    };

    // --- Styles ---
    const pageContainerStyle = {
        padding: isMobile ? '100px 15px 100px' : '140px 10% 80px',
        textAlign: 'center',
        background: '#f8fafc',
        minHeight: '100vh',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    };

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: isMobile 
            ? 'repeat(auto-fit, minmax(140px, 1fr))' 
            : 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: isMobile ? '12px' : '30px',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        justifyContent: 'center',
        padding: '0'
    };

    return (
        <div style={pageContainerStyle}>
            <h1 style={{ 
                fontSize: isMobile ? '1.8rem' : '2.5rem', 
                fontWeight: '800', 
                color: '#0f172a', 
                textTransform: 'uppercase',
                letterSpacing: '1px' 
            }}>
                {/* ✅ Օգտագործում ենք տրանսլյացիան */}
                {t('partners_title_prefix')} <span style={{ color: goldColor }}>{t('partners_title_main')}</span>
            </h1>
            
            <div style={{ 
                width: '60px', 
                height: '4px', 
                background: goldColor, 
                margin: '15px auto 40px', 
                borderRadius: '2px' 
            }}></div>
            
            {loading ? (
                <div style={{ color: goldColor, fontWeight: '600', fontSize: '18px', marginTop: '50px' }}>
                    {t('loading')}...
                </div>
            ) : (
                <div style={gridStyle}>
                    {partners.length > 0 ? partners.map(partner => (
                        <div key={partner.id} style={{
                            ...cardStyle,
                            padding: isMobile ? '15px 10px' : '30px 20px'
                        }} className="partner-card">
                            <div style={{
                                ...imageWrapper,
                                height: isMobile ? '70px' : '100px'
                            }}>
                               <img 
    src={getPartnerImage(partner.image)} 
    alt={partner.name || "Partner"} 
    style={imgStyle}
    loading="lazy"       // 1. Բեռնել միայն երբ օգտատերը հասնի սլայդերին
    decoding="async"     // 2. Թեթևացնել բրաուզերի գործը
    onError={(e) => { 
        e.target.onerror = null; 
        e.target.src = "https://via.placeholder.com/150?text=No+Logo"; 
    }} 
/>
                            </div>
                            {partner.name && (
                                <p style={{ 
                                    marginTop: '15px', 
                                    color: '#334155', 
                                    fontWeight: '700', 
                                    fontSize: isMobile ? '11px' : '14px',
                                    textTransform: 'uppercase',
                                    textAlign: 'center'
                                }}>
                                    {partner.name}
                                </p>
                            )}
                        </div>
                    )) : (
                        <p style={{ color: '#64748b', gridColumn: '1/-1', marginTop: '40px' }}>
                            {t('no_partners')}
                        </p>
                    )}
                </div>
            )}

            <style>
                {`
                    .partner-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 30px rgba(0,0,0,0.08) !important;
                        border-color: ${goldColor} !important;
                    }
                `}
            </style>
        </div>
    );
};

const cardStyle = {
    background: '#fff',
    borderRadius: '20px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.02)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s ease-in-out',
    border: '1px solid #f1f5f9',
    cursor: 'default'
};

const imageWrapper = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const imgStyle = {
    maxWidth: '90%',
    maxHeight: '100%',
    objectFit: 'contain'
};

export default Partners;